module.exports = __webpack_public_path__ + "static/media/ts_help3.caaffafa.png";